import React, { useEffect, useRef, useState } from 'react';
import { useQuill } from 'react-quilljs';
import 'quill/dist/quill.snow.css';
import Layout from '../Layout/Layout.js';
import { APIUrl } from '../../Helper/APIUrl';
import { useSnackbar } from "notistack";
import { useSearchParams } from "react-router-dom";

const quillModules = {
    toolbar: [
        [{ header: [1, 2, 3, false] }],
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['link', 'image', 'code-block'],
        ['clean']
    ]
};

const quillFormats = [
    'header',
    'bold',
    'italic',
    'underline',
    'list',
    'bullet',
    'link',
    'image',
    'code-block'
];

const MAX_IMAGE_SIZE_BYTES = 1.5 * 1024 * 1024;
const MAX_EDITOR_IMAGE_SIZE_BYTES = 2 * 1024 * 1024;
const ALLOWED_IMAGE_EXTENSIONS = /\.(jpg|jpeg|png)$/i;
const DUMMY_IMAGE_PREVIEW = 'https://dummyimage.com/200x200/f1f5f9/64748b&text=IMG';

const getPlainTextFromHtml = (html) => {
    if (!html) {
        return '';
    }

    return html.replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ').trim();
};

function PageDetail() {

    const Token = JSON.parse(localStorage.getItem('tcn'));
    const localStorageUserId = JSON.parse(localStorage.getItem('userid'));
    const { enqueueSnackbar } = useSnackbar();

    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");

    const [ddlPageURLMaster, setddlPageURLMaster] = useState([]);

    const [DetailId, setDetailId] = useState(0);
    const [URLId, setURLId] = useState(0);
    const [Title, setTitle] = useState("");
    const [ShortDescription, setShortDescription] = useState("");
    const [Description, setDescription] = useState("");
    const [ImagePath, setImagePath] = useState("");
    const [ImageFile, setImageFile] = useState(null);
    const [ImageAltText, setImageAltText] = useState("");
    const [ImageTitle, setImageTitle] = useState("");
    const [ImageCaption, setImageCaption] = useState("");
    const [ImageDescription, setImageDescription] = useState("");
    const [UploadedBy, setUploadedBy] = useState("");
    const [TOCHeading, setTOCHeading] = useState("");
    const [FAQHeading, setFAQHeading] = useState("");
    const [YoutubeVideoHeading, setYoutubeVideoHeading] = useState("");
    const [YoutubeVideoURL, setYoutubeVideoURL] = useState("");
    const [IsActive, setIsActive] = useState(true);
    const [CreatedBy, setCreatedBy] = useState(localStorageUserId || 0);

    const [State, setState] = useState("");
    const [City, setCity] = useState("");
    const [PropertyTypeName, setPropertyTypeName] = useState("");
    const [PageURL, setPageURL] = useState("");
    const [ImageError, setImageError] = useState("");
    const imageInputRef = useRef(null);
    const pageURLSelectRef = useRef(null);
    const imageUploadButtonRef = useRef(null);
    const descriptionEditorRef = useRef(null);

    const [flagAlreadyUpdated, setflagAlreadyUpdated] = useState(false);

    const TitleRef = useRef(null);
    const ShortDescriptionRef = useRef(null);
    const ImagePathRef = useRef(null);
    const ImageFileRef = useRef(null);
    const ImageAltTextRef = useRef(null);
    const ImageTitleRef = useRef(null);
    const ImageCaptionRef = useRef(null);
    const ImageDescriptionRef = useRef(null);
    const UploadedByRef = useRef(null);
    const TOCHeadingRef = useRef(null);
    const FAQHeadingRef = useRef(null);
    const YoutubeVideoHeadingRef = useRef(null);
    const YoutubeVideoURLRef = useRef(null);

    useEffect(() => {
        getddlPageURLMaster();
    }, [])

    useEffect(() => {
        if (!id || isNaN(id) || ddlPageURLMaster.length === 0) {
            return;
        }

        handleDDLChange(id);
    }, [id, ddlPageURLMaster]);

    // Safe JSON parse helper to avoid "Unexpected end of JSON input"
    const parseJSON = async (response) => {
        try {
            const text = await response.text();
            if (!text) return null;
            return JSON.parse(text);
        }
        catch (err) {
            console.warn('Failed to parse JSON response', err);
            return null;
        }
    }

    const getddlPageURLMaster = async () => {
        try {
            const response = await fetch(APIUrl.PageURLMaster + 'GetAllPageURLMaster', {
                method: "Post",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Token}`
                },
                body: JSON.stringify()
            });

            const result = await parseJSON(response);

            if (result.Message == "Success") {
                setddlPageURLMaster(result.data);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const handleDDLChange = (id) => {

        const filterPageURLMaster = ddlPageURLMaster.find(x => x.URLId == id);
        if (filterPageURLMaster) {
            setState(filterPageURLMaster.State);
            setCity(filterPageURLMaster.City);
            setPageURL(filterPageURLMaster.PageURL);
            setPropertyTypeName(filterPageURLMaster.PropertyTypeName);
            setURLId(filterPageURLMaster.URLId);
            fnGetMyDetailPageByURLId(filterPageURLMaster.URLId);

        }
        else {
            setState("");
            setCity("");
            setPageURL("");
            setPropertyTypeName("");
            setURLId(0);

        }

        if (id == 0 || id == "0") {
            resetForm();
        }
    }

    const fnGetMyDetailPageByURLId = async (id) => {
        try {
            const response = await fetch(APIUrl.DetailPage + 'GetDetailPageByURLId/' + id, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Token}`
                }
            });

            const result = await parseJSON(response);
            if (result.Message == "Success" && result.data) {
                const detailData = result.data;
                setDetailId(detailData.DetailId);
                setTitle(detailData.Title);
                setShortDescription(detailData.ShortDescription);
                setDescription(detailData.Description);
                setImagePath(APIUrl.BaseUrl + detailData.ImagePath);
                setImageAltText(detailData.ImageAltText);
                setImageTitle(detailData.ImageTitle);
                setImageCaption(detailData.ImageCaption);
                setImageDescription(detailData.ImageDescription);
                setUploadedBy(detailData.UploadedBy);
                setTOCHeading(detailData.TOCHeading);
                setFAQHeading(detailData.FAQHeading);
                setYoutubeVideoHeading(detailData.YoutubeVideoHeading);
                setYoutubeVideoURL(detailData.YoutubeVideoURL);
                setflagAlreadyUpdated(true);
            }
            else{
                 setDetailId("");
                setTitle("");
                setShortDescription("");
                setDescription("");
                setImagePath("");
                setImageAltText("");
                setImageTitle("");
                setImageCaption("");
                setImageDescription("");
                setUploadedBy("");
                setTOCHeading("");
                setFAQHeading("");
                setYoutubeVideoHeading("");
                setYoutubeVideoURL("");
            }
        }
        catch (error) {
            console.log(error);
        }
    }


    const handleImageUploadClick = () => {
        imageInputRef.current?.click();
    };

    const handleImageChange = (event) => {
        const file = event.target.files?.[0];

        if (!file) {
            return;
        }

        const isValidType =
            ['image/jpeg', 'image/png'].includes(file.type) || ALLOWED_IMAGE_EXTENSIONS.test(file.name);

        if (!isValidType) {
            setImageError('Only JPG, JPEG, or PNG files are allowed.');
            event.target.value = '';
            return;
        }

        if (file.size > MAX_IMAGE_SIZE_BYTES) {
            setImageError('File size must be less than or equal to 1.5 MB.');
            event.target.value = '';
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            setImageFile(file);
            setImagePath(typeof reader.result === 'string' ? reader.result : '');
            setImageError('');
            event.target.value = '';
            setflagAlreadyUpdated(false);
        };
        reader.readAsDataURL(file);
    };

    const resetForm = () => {
        setDetailId(0);
        setURLId(0);
        setTitle('');
        setShortDescription('');
        setDescription('');
        setImagePath('');
        setImageFile(null);
        setImageAltText('');
        setImageTitle('');
        setImageCaption('');
        setImageDescription('');
        setUploadedBy('');
        setTOCHeading('');
        setFAQHeading('');
        setYoutubeVideoHeading('');
        setYoutubeVideoURL('');
        setState('');
        setCity('');
        setPropertyTypeName('');
        setPageURL('');
        setImageError('');
        if (imageInputRef.current) {
            imageInputRef.current.value = '';
        }
    };

    const validateAndSubmit = async () => {
        const authToken = typeof Token === 'string'
            ? Token
            : Token?.token || Token?.Token || '';

        const validations = [
            { isInvalid: !authToken, message: 'Please login first.' },
            { isInvalid: !URLId, message: 'Please Select Page URL.', focus: () => pageURLSelectRef.current?.focus() },
            { isInvalid: !State.trim(), message: 'State is required.', focus: () => pageURLSelectRef.current?.focus() },
            { isInvalid: !City.trim(), message: 'City is required.', focus: () => pageURLSelectRef.current?.focus() },
            { isInvalid: !PropertyTypeName.trim(), message: 'Property Type is required.', focus: () => pageURLSelectRef.current?.focus() },
            { isInvalid: !PageURL.trim(), message: 'Master Page URL is required.', focus: () => pageURLSelectRef.current?.focus() },
            { isInvalid: !Title.trim(), message: 'Title is required.', focus: () => TitleRef.current?.focus() },
            { isInvalid: !ShortDescription.trim(), message: 'Short Description is required.', focus: () => ShortDescriptionRef.current?.focus() },
            { isInvalid: !getPlainTextFromHtml(Description), message: 'Description is required.', focus: () => descriptionEditorRef.current?.focus() },
            { isInvalid: !!ImageError, message: ImageError, focus: () => imageUploadButtonRef.current?.focus() },

           // { isInvalid: !ImageFile && !flagAlreadyUpdated, message: 'Please upload image.', focus: () => imageUploadButtonRef.current?.focus() },
            { isInvalid: !ImageAltText.trim(), message: 'Image Alt is required.', focus: () => ImageAltTextRef.current?.focus() },
            { isInvalid: !ImageTitle.trim(), message: 'Image Title is required.', focus: () => ImageTitleRef.current?.focus() },
            { isInvalid: !ImageCaption.trim(), message: 'Image Caption is required.', focus: () => ImageCaptionRef.current?.focus() },
            { isInvalid: !ImageDescription.trim(), message: 'Image Description is required.', focus: () => ImageDescriptionRef.current?.focus() },
            { isInvalid: !UploadedBy.trim(), message: 'Written By is required.', focus: () => UploadedByRef.current?.focus() },
            { isInvalid: !TOCHeading.trim(), message: 'TOC Heading is required.', focus: () => TOCHeadingRef.current?.focus() },
            { isInvalid: !FAQHeading.trim(), message: 'FAQ Heading is required.', focus: () => FAQHeadingRef.current?.focus() },
            { isInvalid: !YoutubeVideoHeading.trim(), message: 'Youtube Video Heading is required.', focus: () => YoutubeVideoHeadingRef.current?.focus() },
            { isInvalid: !YoutubeVideoURL.trim(), message: 'Youtube Video URL is required.', focus: () => YoutubeVideoURLRef.current?.focus() }
        ];

        const failedValidation = validations.find((item) => item.isInvalid);
        if (failedValidation) {
            enqueueSnackbar(failedValidation.message, { variant: 'warning' });
            failedValidation.focus?.();
            return;
        }

        try {
            const data = {
                DetailId: Number(DetailId) || 0,
                URLId: Number(URLId) || 0,
                Title: Title.trim(),
                ShortDescription: ShortDescription.trim(),
                Description,
                ImagePath: '',
                ImageAltText: ImageAltText.trim(),
                ImageTitle: ImageTitle.trim(),
                ImageCaption: ImageCaption.trim(),
                ImageDescription: ImageDescription.trim(),
                UploadedBy: UploadedBy.trim(),
                TOCHeading: TOCHeading.trim(),
                FAQHeading: FAQHeading.trim(),
                YoutubeVideoHeading: YoutubeVideoHeading.trim(),
                YoutubeVideoURL: YoutubeVideoURL.trim(),
                IsActive,
                CreatedBy: Number(CreatedBy) || null
            };

            const formData = new FormData();
            formData.append('detailPageJson', JSON.stringify(data));
            if (!flagAlreadyUpdated && ImageFile) {
                formData.append('photo', ImageFile);
            }


            const response = await fetch(APIUrl.DetailPage + 'InsertDetailPage', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${authToken}`
                },
                body: formData
            });

            const result = await parseJSON(response);

            if (result?.Message === 'Success' || result?.returnID > 0 || response.ok) {
                enqueueSnackbar(result?.Message || 'Successfully Added', { variant: 'success' });
                return;
            }

            enqueueSnackbar(result?.Message || 'Failed to save page detail.', { variant: 'error' });
        }
        catch (error) {
            console.log(error);
            enqueueSnackbar(error?.message || 'Error while saving page detail.', { variant: 'error' });
        }
    };



    return (
        <Layout>
            <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8 bg-slate-50">
                <div className="mx-auto w-full max-w-[1500px] rounded-xl border border-slate-200 bg-white shadow-sm">
                    <div className="flex flex-col gap-3 border-b border-slate-200 p-4 sm:p-5 md:flex-row md:items-center md:justify-between">
                        <div>
                            <h1 className="text-xl font-semibold text-slate-900">Page Details</h1>
                            <p className="mt-1 text-sm text-slate-600">{ }</p>
                        </div>
                        <button
                            type="button"
                            onClick={() => window.location.assign('/pageurlmaster')}
                            className="rounded-md bg-indigo-600 px-4 py-2 text-xs font-semibold text-white shadow-sm transition hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:ring-offset-2"
                        >
                           Back to Page URL Master
                        </button>
                    </div>

                    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 border-b border-slate-200 p-4 sm:p-5">
                        <select
                            ref={pageURLSelectRef}
                            value={URLId}
                            onChange={(e) => handleDDLChange(e.target.value)}
                            disabled
                            className="w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100">
                            <option value={0}>Select Page URL</option>
                            {
                                ddlPageURLMaster.map((item) => (
                                    <option key={item.URLId} value={item.URLId}>{item.PageURL}</option>
                                ))
                            }
                        </select>
                    </div>

                    <div className="space-y-4 p-4 sm:p-5">
                        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                            <div>
                                <label className='mb-1.5 block text-xs font-semibold text-slate-600'>State</label>
                                <input
                                    type='text'
                                    className='w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100'
                                    value={State}
                                    disabled={true}
                                />
                            </div>
                            <div>
                                <label className='mb-1.5 block text-xs font-semibold text-slate-600'>City</label>
                                <input
                                    type='text'
                                    className='w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100'
                                    value={City}
                                    disabled={true}
                                />
                            </div>
                            <div>
                                <label className='mb-1.5 block text-xs font-semibold text-slate-600'>Property Type</label>
                                <input
                                    type='text'
                                    className='w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100'
                                    value={PropertyTypeName}
                                    disabled={true}
                                />
                            </div>
                            <div>
                                <label className='mb-1.5 block text-xs font-semibold text-slate-600'>Master Page URL</label>
                                <input
                                    type='text'
                                    className='w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100'
                                    value={PageURL}
                                    disabled={true}
                                />
                            </div>
                        </div>
                        <div>
                            <label className='mb-1.5 block text-xs font-semibold text-slate-600'>Title</label>
                            <input
                                ref={TitleRef}
                                type='text'
                                className='w-full rounded-md border border-slate-300 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100'
                                value={Title}
                                onChange={(e) => setTitle(e.target.value)}
                                minLength={150}
                            />
                        </div>
                        <div>
                            <label className='mb-1.5 block text-xs font-semibold text-slate-600'>Short Description</label>
                            <textarea
                                ref={ShortDescriptionRef}
                                className='w-full rounded-md border border-slate-300 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100'
                                value={ShortDescription}
                                onChange={(e) => setShortDescription(e.target.value)}
                                minLength={150}
                                rows={3}
                            />
                        </div>

                        <div>
                            <label className="mb-1.5 block text-xs font-semibold text-slate-600">Description</label>
                            <HtmlEditor
                                value={Description}
                                onChange={setDescription}
                                onReady={(editor) => {
                                    descriptionEditorRef.current = editor;
                                }}
                                placeholder="Write page description here..."
                            />
                        </div>

                        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                            <div>
                                <label className="mb-1.5 block text-xs font-semibold text-slate-600">Upload Image</label>
                                <input
                                    ref={imageInputRef}
                                    type="file"
                                    accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                                    className="hidden"
                                    onChange={handleImageChange}
                                />
                                <div className="flex w-full max-w-xs items-center gap-3 rounded-lg border border-slate-300 bg-slate-50 p-3">
                                    <div className="h-14 w-14 overflow-hidden rounded border border-slate-200 bg-white">
                                        <img
                                            src={ImagePath || DUMMY_IMAGE_PREVIEW}
                                            alt="Preview"
                                            className="h-full w-full object-cover"
                                        />
                                    </div>
                                    <button
                                        ref={imageUploadButtonRef}
                                        type="button"
                                        onClick={handleImageUploadClick}
                                        className="rounded-md border border-slate-300 bg-white px-4 py-2 text-xs font-semibold text-slate-700 transition hover:border-indigo-300 hover:text-indigo-600"
                                    >
                                        Upload
                                    </button>
                                </div>
                                <p className="mt-1 text-[11px] text-slate-500">Allowed: JPG, JPEG, PNG | Max size: 1.5 MB</p>
                                {ImageError && <p className="mt-1 text-xs font-medium text-red-600">{ImageError}</p>}
                            </div>
                            <div>
                                <label className="mb-1.5 block text-xs font-semibold text-slate-600">Image Alt</label>
                                <input
                                    ref={ImageAltTextRef}
                                    type="text"
                                    value={ImageAltText}
                                    onChange={(e) => setImageAltText(e.target.value)}
                                    className="w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100"
                                />
                            </div>
                            <div>
                                <label className="mb-1.5 block text-xs font-semibold text-slate-600">Image Title</label>
                                <input
                                    ref={ImageTitleRef}
                                    type="text"
                                    value={ImageTitle}
                                    onChange={(e) => setImageTitle(e.target.value)}
                                    className="w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100"
                                />
                            </div>
                            <div>
                                <label className="mb-1.5 block text-xs font-semibold text-slate-600">Image Caption</label>
                                <input
                                    ref={ImageCaptionRef}
                                    type="text"
                                    value={ImageCaption}
                                    onChange={(e) => setImageCaption(e.target.value)}
                                    className="w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100"
                                />
                            </div>
                            <div>
                                <label className="mb-1.5 block text-xs font-semibold text-slate-600">Image Description</label>
                                <input
                                    ref={ImageDescriptionRef}
                                    type="text"
                                    value={ImageDescription}
                                    onChange={(e) => setImageDescription(e.target.value)}
                                    className="w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100"
                                />
                            </div>
                            <div>
                                <label className="mb-1.5 block text-xs font-semibold text-slate-600">Written By</label>
                                <input
                                    ref={UploadedByRef}
                                    type="text"
                                    value={UploadedBy}
                                    onChange={(e) => setUploadedBy(e.target.value)}
                                    className="w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100"
                                />
                            </div>
                        </div>

                        <div>
                            <label className="mb-1.5 block text-xs font-semibold text-slate-600">TOC Heading</label>
                            <input
                                ref={TOCHeadingRef}
                                type="text"
                                value={TOCHeading}
                                onChange={(e) => setTOCHeading(e.target.value)}
                                className="w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100"
                            />
                        </div>

                        <div>
                            <label className="mb-1.5 block text-xs font-semibold text-slate-600">FAQ Heading</label>
                            <input
                                ref={FAQHeadingRef}
                                type="text"
                                value={FAQHeading}
                                onChange={(e) => setFAQHeading(e.target.value)}
                                className="w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100"
                            />
                        </div>

                        <div>
                            <label className="mb-1.5 block text-xs font-semibold text-slate-600">Youtube Video Heading</label>
                            <input
                                ref={YoutubeVideoHeadingRef}
                                type="text"
                                value={YoutubeVideoHeading}
                                onChange={(e) => setYoutubeVideoHeading(e.target.value)}
                                placeholder="Enter Youtube Video Heading"
                                className="w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100"
                            />
                        </div>

                        <div>
                            <label className="mb-1.5 block text-xs font-semibold text-slate-600">Youtube Video URL</label>
                            <input
                                ref={YoutubeVideoURLRef}
                                type="text"
                                value={YoutubeVideoURL}
                                onChange={(e) => setYoutubeVideoURL(e.target.value)}
                                placeholder="video url"
                                className="w-full rounded-md border border-slate-300 bg-slate-100 px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-indigo-400 focus:bg-white focus:ring-2 focus:ring-indigo-100"
                            />
                        </div>

                        <div className="flex flex-wrap items-center gap-2 pt-2">
                            <button
                                type="button"
                                onClick={validateAndSubmit}
                                className="rounded-md bg-blue-600 px-4 py-2 text-xs font-semibold text-white shadow-sm transition hover:bg-blue-700"
                            >
                                Update
                            </button>
                        </div>
                    </div>
                </div>
            </main>
        </Layout>
    );
}


function HtmlEditor({ value, onChange, placeholder = '', onReady }) {
    const editorImageInputRef = useRef(null);
    const { quill, quillRef } = useQuill({
        theme: 'snow',
        modules: quillModules,
        formats: quillFormats,
        placeholder
    });

    useEffect(() => {
        if (quill && onReady) {
            onReady(quill);
        }
    }, [quill, onReady]);

    useEffect(() => {
        if (!quill) {
            return;
        }

        const toolbar = quill.getModule('toolbar');
        if (!toolbar) {
            return;
        }

        const handleInsertLink = () => {
            const url = window.prompt('Enter link URL');
            if (!url) {
                return;
            }

            const range = quill.getSelection(true);
            const index = range ? range.index : quill.getLength();
            quill.insertText(index, url, 'link', url, 'user');
            quill.setSelection(index + url.length, 0, 'user');
        };

        const handleInsertImage = () => {
            editorImageInputRef.current?.click();
        };

        const handleInsertVideo = () => {
            const videoUrl = window.prompt('Enter YouTube/Vimeo embed URL');
            if (!videoUrl) {
                return;
            }

            const range = quill.getSelection(true);
            const index = range ? range.index : quill.getLength();
            quill.insertEmbed(index, 'video', videoUrl, 'user');
            quill.setSelection(index + 1, 0, 'user');
        };

        toolbar.addHandler('link', handleInsertLink);
        toolbar.addHandler('image', handleInsertImage);
        toolbar.addHandler('video', handleInsertVideo);
    }, [quill]);

    const handleEditorImageChange = (event) => {
        const file = event.target.files?.[0];
        if (!file || !quill) {
            return;
        }

        const isValidType = ['image/jpeg', 'image/png'].includes(file.type) || ALLOWED_IMAGE_EXTENSIONS.test(file.name);
        if (!isValidType) {
            window.alert('Only JPG, JPEG, or PNG files are allowed in the editor.');
            event.target.value = '';
            return;
        }

        if (file.size > MAX_EDITOR_IMAGE_SIZE_BYTES) {
            window.alert('Editor image size must be less than or equal to 2 MB.');
            event.target.value = '';
            return;
        }

        const reader = new FileReader();
        reader.onload = () => {
            const base64 = typeof reader.result === 'string' ? reader.result : '';
            if (!base64) {
                event.target.value = '';
                return;
            }

            const range = quill.getSelection(true);
            const index = range ? range.index : quill.getLength();
            quill.insertEmbed(index, 'image', base64, 'user');
            quill.setSelection(index + 1, 0, 'user');
            event.target.value = '';
        };

        reader.readAsDataURL(file);
    };

    useEffect(() => {
        if (!quill) {
            return;
        }

        const nextValue = value || '';
        const currentValue = quill.root.innerHTML === '<p><br></p>' ? '' : quill.root.innerHTML;

        if (currentValue !== nextValue) {
            if (nextValue) {
                quill.clipboard.dangerouslyPasteHTML(nextValue);
            }
            else {
                quill.setText('');
            }
        }
    }, [quill, value]);

    useEffect(() => {
        if (!quill) {
            return;
        }

        const handleChange = () => {
            const html = quill.root.innerHTML;
            onChange(html === '<p><br></p>' ? '' : html);
        };

        quill.on('text-change', handleChange);

        return () => {
            quill.off('text-change', handleChange);
        };
    }, [quill, onChange]);

    return (
        <div className="overflow-hidden rounded-md border border-slate-300 bg-white [&_.ql-container]:min-h-[220px] [&_.ql-container]:border-0 [&_.ql-editor]:min-h-[220px] [&_.ql-editor]:text-sm [&_.ql-toolbar]:border-x-0 [&_.ql-toolbar]:border-t-0">
            <input
                ref={editorImageInputRef}
                type="file"
                accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                className="hidden"
                onChange={handleEditorImageChange}
            />
            <div ref={quillRef} />
        </div>
    );
}

export default PageDetail;